import {analyticsLogEvent} from '../api'

const eventName = 'pwa_page'

interface Parameters {
    pageCategory: string
    pagesubCategory: string
    pageDetail: string
    pageLanguage: string
    pageStatus: string
    listingType: string
    menuWidget?: string
}

/**
 * Tracks an internal search event on a page.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.pageCategory - Category of the page.
 * @param {string} params.pagesubCategory - Sub-category of the page.
 * @param {string} params.pageDetail - Additional page details.
 * @param {string} params.pageLanguage - Language of the page.
 * @param {string} params.pageStatus - Status of the page.
 * @param {string} params.listingType - Type of listing on the page.
 * @param {string} [params.menuWidget] - Optional menu widget.
 */
export function analyticsEventPwaPage({pageCategory, pagesubCategory, pageDetail, pageLanguage, pageStatus, listingType, menuWidget}: Parameters): void {
    const eventDetails = {
        pageCategory: pageCategory,
        pagesubCategory: pagesubCategory,
        pageDetail: pageDetail,
        pageLanguage: pageLanguage,
        pageStatus: pageStatus,
        listingType: listingType,
        menu_widget: menuWidget,
    }

    analyticsLogEvent(eventName, eventDetails)
}
